import Image from 'next/image';
import classNames from 'classnames';
import { useRef, useState } from 'react';

import { SectionTitle } from '@/ui/index';
import { PlayIcon } from '@/icons/PlayIcon';

import styles from './ServiceVideo.module.scss';

const ServiceVideo = ({ data }) => {
  const videoRef = useRef(null);
  const [visible, setVisible] = useState(true);

  const playHandler = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setVisible(false);
    } else {
      videoRef.current.pause();
      setVisible(true);
    }
  };

  return (
    <div
      className={styles.customWrapper}
      itemScope
      itemType='https://schema.org/VideoObject'
    >
      <section className={classNames([styles.cover_youtube_video], 'wrapper')}>
        <div className={styles.videoWrapper}>
          <video
            onClick={playHandler}
            ref={videoRef}
            className={styles.customVideo}
            width='900'
            height='560'
            poster='/videoThumbnail.png'
            onEnded={() => setVisible(true)}
          >
            <source src='/assets/5gVideo.mp4' />
          </video>
          <div
            onClick={playHandler}
            className={classNames(styles.controls, {
              [styles.hidden]: !visible,
            })}
          >
            <PlayIcon />
          </div>
        </div>

        {data?.title && (
          <SectionTitle titleModify={'title--medium'} className={styles.title}>
            <Image
              src={data?.icon}
              height={24}
              width={24}
              alt={data?.title}
              title={data?.title}
            />
            {data?.title}
          </SectionTitle>
        )}
      </section>
    </div>
  );
};

export default ServiceVideo;
